import type { CSSProperty } from '../CSSProperty';
import { mergePoints } from '../parser/points';

export class CSSPropertyPoints
  implements
    Partial<
      CSSProperty<
        {
          points: [number, number][];
          totalLength: number;
          segments: [number, number][];
        },
        {
          points: [number, number][];
          totalLength: number;
          segments: [number, number][];
        }
      >
    >
{
  mixer = mergePoints;
}
